import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { waLink } from "@/data/site";
import { WhatsAppIcon } from "./Footer";

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
    <motion.a
      data-testid="whatsapp-float"
      href={waLink(t.form.waMsg)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 200 }}
      className="fixed bottom-24 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-black/20 transition-transform duration-200 hover:scale-110 md:bottom-6 md:right-6"
    >
      <WhatsAppIcon size={28} />
    </motion.a>
  );
};
